import './Contact.css';
import React, { useContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { isEmailValid } from '../../utility/utilityfunctions';
import contactContext from '../../context/contact/contactcontext';
import progressContext from '../../context/loading/progresscontext';
import Breadcrumb from '../Breadcrumb/Breadcrumb';
import CtaBand from '../home/ctaband/CtaBand';

function Contact() {
  const { contactInfo, sendInquiryDetails } = useContext(contactContext);
  const { setProgress } = useContext(progressContext);

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  const { shortText } = contactInfo || {};
  const address = contactInfo && contactInfo.address ? JSON.parse(contactInfo.address) : {};
  const email = contactInfo && contactInfo.email ? JSON.parse(contactInfo.email) : {};
  const phone = contactInfo && contactInfo.phone ? JSON.parse(contactInfo.phone) : {};

  const displayPhone = phone.phone || "080 2334 7276";
  const displayEmail = email.email || "lakshmimaternityhome@gmail.com";
  const displayAddress = address.address || "95 & 96, Margosa Road, Opposite Malleswaram Exchange, Malleswaram, Bangalore";

  useEffect(() => {
    if (setProgress) {
      setProgress(70);
      setTimeout(() => {
        setProgress(100);
      }, 100);
    }
  }, [setProgress]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formData.email && !isEmailValid(formData.email)) {
      toast.error("Please enter a valid email address!", { theme: "colored" });
      return;
    }

    sendInquiryDetails({
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      subject: formData.subject || "Website Inquiry",
      message: formData.message
    });

    toast.success("Thank you! Your message has been sent.", { theme: "colored" });
    setFormData({
      name: '',
      email: '',
      phone: '',
      subject: '',
      message: ''
    });
  };

  return (
    <main className="contact-page">
      <Breadcrumb
        pageName="Contact Us"
        bgImage="/img/uplaods/rad.jpg"
        path={[
          { label: 'Home', href: '/' },
          { label: 'Contact Us' }
        ]}
      />

      <section className="band tint" id="contact">
        <div className="wrap">
          <div className="contact-grid">
            <div>
              <p className="eyebrow">Visit us</p>
              <h2 className="h-sec">Margosa Road, Malleswaram.</h2>
              <p className="body-copy" style={{ marginTop: '22px' }}>
                {shortText || "We are opposite the Malleswaram Exchange, in the heart of north Bangalore. Call ahead and we will tell you the quickest way in."}
              </p>

              <ul className="cinfo">
                <li>
                  <span className="lbl">Address</span>
                  <span>{displayAddress}</span>
                </li>
                <li>
                  <span className="lbl">Phone</span>
                  <span><a href={`tel:${displayPhone.replace(/\s+/g, '')}`}>{displayPhone}</a></span>
                </li>
                <li>
                  <span className="lbl">Email</span>
                  <span><a href={`mailto:${displayEmail}`}>{displayEmail}</a></span>
                </li>
                <li>
                  <span className="lbl">Labour &amp; delivery</span>
                  <span>Available 24 hours, every day of the year</span>
                </li>
                <li>
                  <span className="lbl">Directions</span>
                  <span>
                    <a
                      href="https://maps.google.com/?q=Lakshmi+Maternity+%26+Surgical+Centre,+Margosa+Road,+Malleswaram,+Bangalore"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Open in Google Maps
                    </a>
                  </span>
                </li>
              </ul>
            </div>

            <form className="inquiry-form" onSubmit={handleSubmit}>
              <h3>Send an inquiry</h3>
              <p className="inquiry-lead">
                Fill in your details below and our hospital team will get in touch with you shortly.
              </p>

              <div className="field">
                <label htmlFor="c-name">Full name *</label>
                <input
                  id="c-name"
                  name="name"
                  type="text"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="field">
                <label htmlFor="c-phone">Phone number *</label>
                <input
                  id="c-phone"
                  name="phone"
                  type="tel"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="field">
                <label htmlFor="c-email">Email address</label>
                <input
                  id="c-email"
                  name="email"
                  type="email"
                  value={formData.email}
                  onChange={handleChange}
                />
              </div>

              <div className="field">
                <label htmlFor="c-subject">Subject</label>
                <input
                  id="c-subject"
                  name="subject"
                  type="text"
                  value={formData.subject}
                  onChange={handleChange}
                  placeholder="e.g. Appointment enquiry, pregnancy scan query"
                />
              </div>

              <div className="field">
                <label htmlFor="c-msg">Message</label>
                <textarea
                  id="c-msg"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="How can we assist you?"
                ></textarea>
              </div>

              <button className="btn btn-solid" type="submit" style={{ marginTop: '22px', width: '100%' }}>
                Send Message
              </button>
            </form>
          </div>

          <div className="contact-map-frame">
            <iframe
              title="Lakshmi Maternity Location Map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.4984260322253!2d77.56714947593855!3d13.003923487314565!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae16258bb48a67%3A0x77ee2da385012c36!2sLakshmi%20Maternity%20%26%20Surgical%20Center!5e0!3m2!1sen!2sin!4v1714131593361!5m2!1sen!2sin"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </section>

      <CtaBand />
    </main>
  );
}

export default Contact;